import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import HttpClient from "./http-client";

export const getSoftwareProvider = () => {
    return (dispatch) =>{
        new HttpClient().get(appApis.softwareProviders).then(response => {
            dispatch({ type: reduxKeys.SET_SOFTWARE_PROVIDER, payload: response?.data?.data?.softwareProviders ?? []})
        }).catch(ex => {})
    }
}

export const getBillingCompanies = () => {
    return (dispatch) =>{
        new HttpClient().get(appApis.billingCompanies).then(response => {
            dispatch({ type: reduxKeys.SET_BILLING_COMPANIES, payload: response?.data?.data?.billingCompanies ?? []})
        }).catch(ex => {
            console.error("getBillingCompanies error:", ex);
        })
    }
}

export const getVehicles = (query="") => {
    return new HttpClient().get(`${appApis.getVehicleApi}${query}`);
}

export const getVehicleRenew = (query="") => {
    return new HttpClient().get(`${appApis.vehicleRenwal}${query}`);
}

export const searchVehicles = (query = "", companyId) => {
    return new HttpClient().get(`${appApis.searchVehicleApi}?vehicleRegno=${query}${companyId ? `&companyId=${companyId}` : ''}`);
}

export const getInvoices = (query="") => {
    return new HttpClient().get(`${appApis.invoiceList}${query}`);
}